export const FETCH_PERMISSION_MATRIX =
  "permissions/FETCH_PERMISSION_MATRIX";
export const UPDATE_PERMISSION_MATRIX =
  "permissions/UPDATE_PERMISSION_MATRIX";
export const INIT_PERMISSION_MATRIX = "permissions/INIT_PERMISSION_MATRIX";

export const fetchPermissionMatrix = (payload) => ({
  type: FETCH_PERMISSION_MATRIX,
  payload,
});

export const updatePermissionMatrix = (payload) => ({
  type: UPDATE_PERMISSION_MATRIX,
  payload,
});

export const initPermissionMatrix = (payload) => ({
  type: INIT_PERMISSION_MATRIX,
  payload,
});
